'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _listing = require('./components/listing');

var _listing2 = _interopRequireDefault(_listing);

var _view = require('./components/view');

var _view2 = _interopRequireDefault(_view);

var _user = require('./components/user.config');

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _user2 = require('./services/user.service');

var _user3 = _interopRequireDefault(_user2);

var _userDataprovider = require('./services/user.dataprovider.service');

var _userDataprovider2 = _interopRequireDefault(_userDataprovider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('users', [_angularUiRouter2.default]).component('usersListing', _listing2.default).component('userView', _view2.default).service('Users', _user3.default).service('UsersDataProvider', _userDataprovider2.default).config(_user.UserConfig).name;

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/modules/users/index.js
 **/